var _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _rect2, _rect3, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _polyline, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _polygon, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _g, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _rect4, _rect5, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _circle, _circle2, _circle3, _circle4, _path117, _path118, _polygon2, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _polyline2, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _polygon3, _polygon4, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeople(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    width: "current",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 327 270",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-18{fill:none;}.cls-2{fill:#fff;}.cls-3{fill:#ffbf4d;}.cls-4{fill:#875c3e;}.cls-5{fill:#63432d;}.cls-6{fill:#1a1a1a;}.cls-7{fill:#c1512f;}.cls-8{fill:#f4f4f4;}.cls-9{fill:#f8824a;}.cls-10{fill:#f2b3a7;}.cls-11{fill:#4c3b38;}.cls-12{fill:#5f89d3;}.cls-13{fill:#c63b2c;}.cls-14{fill:#efab95;}.cls-15{fill:#a8695b;}.cls-16{fill:#445e99;}.cls-17{clip-path:url(#clip-path);}.cls-18{stroke:#4c3b38;stroke-linecap:round;stroke-linejoin:round;stroke-width:0.66px;}.cls-19{fill:#f4b9ab;}.cls-20{fill:#332b24;}.cls-21{fill:#d7e5ff;}.cls-22{fill:#eaa98c;}.cls-23{fill:#bf7658;}.cls-24{fill:#444;}.cls-25{fill:#ffd8ca;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-796.17 -404.59)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M873.84,506.63l2.95,9.54c2.75,8.89,3.22,13.55-1,14.86a17,17,0,0,1-9.61-.76c-3.43-1.52-4.49-4.64-6.48-8.82l-4.84-9Z"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 327,
    height: 270
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1083.31,550H834.73a124.29,124.29,0,0,1,248.58,0Z",
    transform: "translate(-796.17 -404.59)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M997.76,534.37c32.48,0,65.49-2.3,84-2.3s38.07,12.8,31.56,47.39-21.06,64.76-60.13,64.76-57.14-5.36-94-5.36-54.9,5.36-94,5.36-53.62-30.16-60.13-64.76,13-47.39,31.56-47.39,51.54,2.3,84,2.3Z",
    transform: "translate(-796.17 -404.59)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1016.74,595.8c75.53,0,72.43-37.53,72.43-37.53-10,19.15-29.1,24.09-59.43,24.09h-141c-30.33,0-49.47-4.94-59.43-24.09,0,0-3.11,37.53,72.42,37.53Z",
    transform: "translate(-796.17 -404.59)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1029.74,582.61h-141c-28.24,0-49.2-4.12-59.65-24.22a.24.24,0,0,1,.1-.34.25.25,0,0,1,.34.11c10.34,19.87,31.15,24,59.21,24h141c28.07,0,48.88-4.08,59.22-24a.25.25,0,0,1,.34-.11.24.24,0,0,1,.1.34C1079,578.49,1058,582.61,1029.74,582.61Z",
    transform: "translate(-796.17 -404.59)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1038.08,638a14.32,14.32,0,0,1-5.81,3.78c-2.29.9-3.06,2.16-3.06,2.93h20.49a22.9,22.9,0,0,0,0-7",
    transform: "translate(-796.17 -404.59)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1042.38,643.61a20.48,20.48,0,0,0-9.2-2.21c-.29.13-.59.25-.91.37-2.29.9-3.06,2.16-3.06,2.93h14.18A2.65,2.65,0,0,0,1042.38,643.61Z",
    transform: "translate(-796.17 -404.59)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1044.37,637.86a15.27,15.27,0,0,1-5.84,5.75,3.22,3.22,0,0,0-1.11,1.09h12.28a22.9,22.9,0,0,0,0-7Z",
    transform: "translate(-796.17 -404.59)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1029.62,643.61a2,2,0,0,0-.41,1.09h20.49s.08-.39.15-1.09Z",
    transform: "translate(-796.17 -404.59)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1042.29,642.14a.3.3,0,0,1-.15,0c-.69-.52-3.7-1.29-6.11-1.42a.25.25,0,0,1,0-.5c2.33.13,5.56.89,6.39,1.52a.25.25,0,0,1-.15.45Z",
    transform: "translate(-796.17 -404.59)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1043.39,640.35a.28.28,0,0,1-.15,0,11.23,11.23,0,0,0-5.42-1.36.25.25,0,0,1-.24-.26.25.25,0,0,1,.26-.24c1.76.06,4.31.47,5.69,1.45a.25.25,0,0,1,.06.35A.26.26,0,0,1,1043.39,640.35Z",
    transform: "translate(-796.17 -404.59)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1049.7,637.75l-11.62.24,11.83,1.93C1049.88,639.25,1049.81,638.52,1049.7,637.75Z",
    transform: "translate(-796.17 -404.59)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1081.08,638c2.19,2.94,6,2.89,8.31,3.78s3.07,2.16,3.07,2.93h-23a22.51,22.51,0,0,1,0-7",
    transform: "translate(-796.17 -404.59)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1079.5,644.7h13c0-.77-.77-2-3.07-2.93a10.59,10.59,0,0,0-1.16-.36C1085.52,641.52,1081.8,642.12,1079.5,644.7Z",
    transform: "translate(-796.17 -404.59)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1075.38,637.86c1.27,2.46,7,4.47,9.23,5.75a3.22,3.22,0,0,1,1.11,1.09h-16.25a22.51,22.51,0,0,1,0-7Z",
    transform: "translate(-796.17 -404.59)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1092.05,643.61a2,2,0,0,1,.41,1.09h-23s-.08-.39-.15-1.09Z",
    transform: "translate(-796.17 -404.59)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1080.21,642.52a.24.24,0,0,1-.21-.12.24.24,0,0,1,.08-.34,14.81,14.81,0,0,1,4-1.5.26.26,0,0,1,.3.19.25.25,0,0,1-.19.3,14,14,0,0,0-3.82,1.44A.31.31,0,0,1,1080.21,642.52Z",
    transform: "translate(-796.17 -404.59)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1078,641.41a.27.27,0,0,1-.18-.08.25.25,0,0,1,0-.35,8.25,8.25,0,0,1,4-1.83.25.25,0,1,1,.08.5,7.79,7.79,0,0,0-3.69,1.68A.27.27,0,0,1,1078,641.41Z",
    transform: "translate(-796.17 -404.59)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1084.28,640.32a7.11,7.11,0,0,1-3.2-2.33l-11.61-.24-.06.4A138.41,138.41,0,0,0,1084.28,640.32Z",
    transform: "translate(-796.17 -404.59)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 232.86,
    y: 177.52,
    width: 6.4,
    height: 4.67
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 250.45,
    y: 113.1,
    width: 10.98,
    height: 21.3
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1060.44,508.67s1-1.44.76-5.3c-.19-2.66-2-4.17-3.07-6.07s-3-2.46-6-2-3.21,0-5.26.07a5.89,5.89,0,0,0-3.65,2c-4.81.69-6,4.25-5.5,7.67s3.46,6.53,3.46,6.53l4.22,2.09,14.09-2.14Z",
    transform: "translate(-796.17 -404.59)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1057.6,523.32a50.58,50.58,0,0,1,1-8.86l-4.39,3.24-7.61,2.1C1047.71,522.93,1052.31,525.3,1057.6,523.32Z",
    transform: "translate(-796.17 -404.59)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1056.45,507.48a3.05,3.05,0,0,0,2.16,1.94l.09,4.49a10.7,10.7,0,0,1-9.19,9.35c-3.64.55-5.93-3.21-7-6.89l-1.26-4.32s-.47-1.85-.74-3.17-.5-4.49-.15-5.45a2.23,2.23,0,0,1,1.61-1.57,14.18,14.18,0,0,0,3.79-1.07c1.76-.77,3-.66,3.83.93a4.92,4.92,0,0,0,4.38,2.16C1055,506.89,1056.08,506.31,1056.45,507.48Z",
    transform: "translate(-796.17 -404.59)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1046.71,515.56a1,1,0,0,1-.37-.08,1.65,1.65,0,0,1-.77-1.64,15.38,15.38,0,0,0-.1-2.09.26.26,0,0,1,.23-.3.27.27,0,0,1,.29.23,15.22,15.22,0,0,1,.1,2.18c0,.57.17,1,.45,1.14s.88-.17,1.51-.84a.26.26,0,0,1,.37,0,.27.27,0,0,1,0,.37A2.64,2.64,0,0,1,1046.71,515.56Z",
    transform: "translate(-796.17 -404.59)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1042.5,514.71a2.6,2.6,0,0,1-2.54-1.85c-.36-1-.74-2.73-.76-2.8a.25.25,0,0,1,.1-.25c.88-.66,3.2-2,5.57-.68a.28.28,0,0,1,.12.18,22.7,22.7,0,0,1,.25,3c0,1.77-1.08,2.17-2.22,2.35A4.73,4.73,0,0,1,1042.5,514.71Zm-2.77-4.6a26.13,26.13,0,0,0,.71,2.58,2.12,2.12,0,0,0,2.51,1.48c1.33-.2,1.78-.67,1.79-1.85a20.82,20.82,0,0,0-.23-2.81A4.62,4.62,0,0,0,1039.73,510.11Z",
    transform: "translate(-796.17 -404.59)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1042.91,512.07a.4.4,0,0,1-.39-.34l-.13-.88a.39.39,0,0,1,.33-.45.38.38,0,0,1,.44.33l.14.89a.39.39,0,0,1-.33.44Z",
    transform: "translate(-796.17 -404.59)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1074.15,562.48l-1.45,9.89h-35.49l-.68,11.15h-8.43c-.08-5.31-.17-15.63.53-22.82l.26-25.84a7.68,7.68,0,0,1,6.84-7.55l7.9-.87,3-1.91a8.14,8.14,0,0,0,.69,4.53c1.29,2.49,2.27,3.86,2.43,4.66s1.12,3.59,1.12,3.59,1-2.54,1.62-3.59a50.49,50.49,0,0,0,2.93-4.66,42.85,42.85,0,0,0,2.19-5.74l3,2.12,12.65,2.88a7.65,7.65,0,0,1,5.93,7l1.53,25.39Z",
    transform: "translate(-796.17 -404.59)"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "277.98 157.89 276.53 167.77 241.04 167.77"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1040.26,508.69a.28.28,0,0,1-.19-.07.28.28,0,0,1,0-.4,4.33,4.33,0,0,1,3.54-.9.29.29,0,0,1-.08.57,3.85,3.85,0,0,0-3,.7A.28.28,0,0,1,1040.26,508.69Z",
    transform: "translate(-796.17 -404.59)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1051.05,517.09a.18.18,0,0,0-.21-.25c-1.55.4-4.19.83-4.71.94s.54,1.43,2.54,1.13A3.11,3.11,0,0,0,1051.05,517.09Z",
    transform: "translate(-796.17 -404.59)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1050.2,513.52a2.07,2.07,0,0,1-2.16-1.62,21.16,21.16,0,0,1-.67-2.95.26.26,0,0,1,.07-.22c2-2,4.82-1.41,5.93-1.07a.26.26,0,0,1,.18.22c0,.08.14,1.82.08,2.91a2.76,2.76,0,0,1-2.59,2.66A6,6,0,0,1,1050.2,513.52Zm-2.32-4.52a21.57,21.57,0,0,0,.64,2.74c.37,1.11,1,1.43,2.45,1.21a2.25,2.25,0,0,0,2.16-2.19c0-.86,0-2.2-.07-2.67A5.4,5.4,0,0,0,1047.88,509Z",
    transform: "translate(-796.17 -404.59)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1039.45,510.35a.35.35,0,0,1-.28-.14.34.34,0,0,1,.08-.47c.9-.67,3.24-2.06,5.66-.69a.35.35,0,0,1,.13.47.33.33,0,0,1-.46.12c-2.07-1.17-4.14.06-4.93.64A.31.31,0,0,1,1039.45,510.35Z",
    transform: "translate(-796.17 -404.59)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1047.62,509.25a.34.34,0,0,1-.24-.58c2-2,4.9-1.44,6-1.09a.33.33,0,0,1,.22.42.33.33,0,0,1-.42.22c-1-.31-3.55-.85-5.35.93A.3.3,0,0,1,1047.62,509.25Z",
    transform: "translate(-796.17 -404.59)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1050.55,510.9a.39.39,0,0,1-.38-.33l-.14-.89a.39.39,0,0,1,.33-.44.38.38,0,0,1,.44.33l.14.88a.39.39,0,0,1-.33.45Z",
    transform: "translate(-796.17 -404.59)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1048.74,507.1a.29.29,0,0,1-.26-.17.3.3,0,0,1,.14-.38,4.38,4.38,0,0,1,3.65-.19.29.29,0,0,1,.08.4.28.28,0,0,1-.39.08,3.9,3.9,0,0,0-3.09.23A.28.28,0,0,1,1048.74,507.1Z",
    transform: "translate(-796.17 -404.59)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "257.19 103.67 263.41 102.72 262.91 103.54 257.2 104.41 257.19 103.67"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1048.07,533.17a.27.27,0,0,1-.17-.06,7,7,0,0,0-1.46-1.06c-.17-.06-.36,0-.78.18a10.12,10.12,0,0,1-1.89.58,1.23,1.23,0,0,1-1.24-.33c-.69-.79-.47-2.85.66-6.12a.25.25,0,0,1,.48.16c-1.46,4.2-1,5.34-.76,5.63a.75.75,0,0,0,.76.17,9.66,9.66,0,0,0,1.8-.55,1.61,1.61,0,0,1,1.13-.19,7.33,7.33,0,0,1,1.64,1.15.26.26,0,0,1,0,.36A.27.27,0,0,1,1048.07,533.17Z",
    transform: "translate(-796.17 -404.59)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1055,532.17a.27.27,0,0,1-.15,0,.24.24,0,0,1-.05-.35,3.85,3.85,0,0,1,1.37-1.2,2.77,2.77,0,0,1,1.53.25,13.91,13.91,0,0,0,1.77.5c.41.09.59,0,.68-.13.66-.62.37-3.11,0-5.71a.25.25,0,0,1,.2-.29.27.27,0,0,1,.29.21c.53,3.33.68,5.41-.1,6.16a1.21,1.21,0,0,1-1.13.25,16.44,16.44,0,0,1-1.83-.51,2.53,2.53,0,0,0-1.22-.25,3.36,3.36,0,0,0-1.12,1A.25.25,0,0,1,1055,532.17Z",
    transform: "translate(-796.17 -404.59)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1037.21,572.37l-1.79-29.09s4.07,24.06,7.35,36.31l-5.56-7.22",
    transform: "translate(-796.17 -404.59)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1047.64,509.09a4.13,4.13,0,0,0-2.9.44l.11.71.09,0a3.44,3.44,0,0,1,2.71-.42h.1Z",
    transform: "translate(-796.17 -404.59)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1058.13,510.32a10.26,10.26,0,0,0,1.15-3c1.2-.49,2.07.09,1.46,3.37a4,4,0,0,1-3.57,3.42Z",
    transform: "translate(-796.17 -404.59)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1037.21,572.37s-3.24,5.64-5.32,9-1.66,10.34-1.28,15.7l3.15,41,17.24-.32-1.49-46.92,8.09-2.94s5.56,2.55,10.79,4.47c0,0-.6,17,.27,45.76l15.95.58s1.64-26.09,2.09-46.91a14.13,14.13,0,0,0-3.39-9.51,67.78,67.78,0,0,0-10.61-9.91h-35.49",
    transform: "translate(-796.17 -404.59)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1083.72,633.92h0l-14.51-.53a.25.25,0,0,1-.24-.26.28.28,0,0,1,.26-.24l14.51.53a.24.24,0,0,1,.24.25A.25.25,0,0,1,1083.72,633.92Z",
    transform: "translate(-796.17 -404.59)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1034.25,633.31a.25.25,0,0,1-.25-.24.26.26,0,0,1,.25-.26l16.08-.3h0a.26.26,0,0,1,.25.24.26.26,0,0,1-.25.26l-16.08.3Z",
    transform: "translate(-796.17 -404.59)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1068.39,592.36c-4.82-3.45-10.79-8.47-10.79-8.47v4S1063.16,590.44,1068.39,592.36Z",
    transform: "translate(-796.17 -404.59)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1057.6,588.14a.25.25,0,0,1-.25-.25v-5.74l-1.19-4.47a.25.25,0,0,1,.48-.13l1.2,4.5s0,0,0,.07v5.77A.25.25,0,0,1,1057.6,588.14Z",
    transform: "translate(-796.17 -404.59)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1051,567.35h-3.28a2.1,2.1,0,0,1-.89-.2l-3-1.42a1.88,1.88,0,0,0-.81-.18h-5a.5.5,0,0,0-.41.79,2.21,2.21,0,0,0,1.9,1h2.17l2.53,1.18h-3a1.44,1.44,0,0,0-.93.34l-2.41,1.95a1.5,1.5,0,0,0-.39.5l-1.11,2.39s.74.77,1.76-.26l-.51,1s.83,1.09,2.87-.64l1.28-.38-1.59,1.79s.44,1.27,2.23,0l1.79-1.28,4.34-.51a9.28,9.28,0,0,0,5-.67C1055.89,571.61,1051,567.35,1051,567.35Z",
    transform: "translate(-796.17 -404.59)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1038.08,573.65a.23.23,0,0,1-.17-.07.25.25,0,0,1,0-.35l1.91-2.06.1-.07,2.23-.89.09,0h3a.25.25,0,0,1,0,.5h-2.94l-2.14.86-1.87,2A.27.27,0,0,1,1038.08,573.65Z",
    transform: "translate(-796.17 -404.59)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1041.72,573.65a.21.21,0,0,1-.18-.09.24.24,0,0,1,0-.35l1.15-1,.12-.06,2.36-.45a.26.26,0,0,1,.29.2.25.25,0,0,1-.2.3l-2.28.43-1.1,1A.23.23,0,0,1,1041.72,573.65Z",
    transform: "translate(-796.17 -404.59)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1079.13,534.6l1.65,27.47a5.74,5.74,0,0,1-3.58,5.67l-22.16,9-4-10.17,18.72-8.3,1.11-17",
    transform: "translate(-796.17 -404.59)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1051,566.82a.25.25,0,0,1-.23-.15.25.25,0,0,1,.13-.33l18.58-8.24,1.1-16.87a.25.25,0,0,1,.26-.23.26.26,0,0,1,.24.27l-1.11,17a.25.25,0,0,1-.15.21l-18.72,8.3Z",
    transform: "translate(-796.17 -404.59)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1070.82,632.31a.26.26,0,0,1-.25-.24,372.5,372.5,0,0,1,.62-39.74,1.6,1.6,0,0,0-.71-1.44l-13-8.57a.25.25,0,1,1,.27-.41l13,8.57a2.08,2.08,0,0,1,.94,1.88,371.58,371.58,0,0,0-.62,39.69.25.25,0,0,1-.24.26Z",
    transform: "translate(-796.17 -404.59)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1048.35,631.8a.26.26,0,0,1-.25-.24L1046,589.78a3.1,3.1,0,0,1,1.72-2.95l8.6-4.3a.26.26,0,0,1,.34.11.25.25,0,0,1-.12.34l-8.6,4.29a2.61,2.61,0,0,0-1.44,2.48l2.13,41.79a.25.25,0,0,1-.24.26Z",
    transform: "translate(-796.17 -404.59)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M850.1,636.27c-2.68,3.19-5,3.45-7.27,4.21a4.85,4.85,0,0,0-3.32,4.22h23.36c0-7-1.79-7.79-1.79-7.79v-4.47Z",
    transform: "translate(-796.17 -404.59)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M886,636.27c2.68,3.19,4.48,3.45,6.78,4.21a4.85,4.85,0,0,1,3.31,4.22H874.27c0-7,1.79-7.79,1.79-7.79v-4.47Z",
    transform: "translate(-796.17 -404.59)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M844.61,574.61l-4.49,1.74a5.31,5.31,0,0,0-3.34,5.69l7.83,55s8.21,2.49,19.24-2.87c0,0-6.41-37.73-7.75-43.47h25.66a429,429,0,0,0-6.7,44s3.64,3.45,16.47,2.11l10.34-53.05c1.15-6.32-10.81-9.19-22-9.19Z",
    transform: "translate(-796.17 -404.59)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M894.81,546.58l-2.12-9.72a3,3,0,0,0-2-2.32l-17.46-11.27v-2h-12v1.24L843.8,534.54a3,3,0,0,0-1.95,2.32l-1.62,9.72",
    transform: "translate(-796.17 -404.59)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M863.29,521.22l-2.69,3.54c2.91,9.13,10.2,9.14,13.86,9.14,3.31,0,6.92-2.42,9-4.25l-10.16-6.38v-2Z",
    transform: "translate(-796.17 -404.59)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M890.23,533.43l-14.79-9.36-5.64,16.31a33.26,33.26,0,0,1-10.95-16.31l-14.77,9.48a7.75,7.75,0,0,0-3.25,4.36l-4.64,16,13.4,3.45-5.74,5.55,3.65,11.68H881l3.33-17.23,12.94-3.64-3.65-15.54A7.73,7.73,0,0,0,890.23,533.43Z",
    transform: "translate(-796.17 -404.59)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M849.59,557.38l-11.23-2.89-1.77,15.27a4.14,4.14,0,0,0,2.92,4.45c4.85,1.47,13.7,4.13,17.23,5.13,5,1.4,4.82,2.17,4.82,2.17a10.6,10.6,0,0,0,1.31,5.49l-.72,2.85-.9,1.15s-1.87.72-1.27,2.17l2.42-1.11,1.19-1.53-.55,1.61s-2.64,1.83-1.19,3.2l2.25-1.88s-1,1.62.26,2.34l2.08-2.8s.47.59,1.2-.09l.93-3.79-.81-7.87c-.17-1.57-.74-2-1.91-3.11-1.7-1.57-11.32-9-19.15-11.83A83.79,83.79,0,0,0,849.59,557.38Z",
    transform: "translate(-796.17 -404.59)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M875.44,524.07l-3.37,9.77a15.54,15.54,0,0,0,11.7-4.5Z",
    transform: "translate(-796.17 -404.59)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M849.59,557.38l-11.23-2.89-1.77,15.27a4.14,4.14,0,0,0,2.92,4.45c4.85,1.47,13.7,4.13,17.23,5.13,5,1.4,4.82,2.17,4.82,2.17a10.6,10.6,0,0,0,1.31,5.49l-.72,2.85-.9,1.15s-1.87.72-1.27,2.17l2.42-1.11,1.19-1.53-.55,1.61s-2.64,1.83-1.19,3.2l2.25-1.88s-1,1.62.26,2.34l2.08-2.8s.47.59,1.2-.09l.93-3.79-.81-7.87c-.17-1.57-.74-2-1.91-3.11-1.7-1.57-11.32-9-19.15-11.83A83.79,83.79,0,0,0,849.59,557.38Z",
    transform: "translate(-796.17 -404.59)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M873.84,506.63l2.95,9.54c2.75,8.89,3.22,13.55-1,14.86-2.27.7-6.92.05-9.6-1.14-3.43-1.53-4.5-4.26-6.49-8.44l-4.84-9Z",
    transform: "translate(-796.17 -404.59)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M874.25,525.65a4.19,4.19,0,0,1-1.74-.32.28.28,0,1,1,.24-.51,4.78,4.78,0,0,0,3.23,0,2.45,2.45,0,0,0,1.65-1.45.28.28,0,0,1,.35-.18.28.28,0,0,1,.19.35,3,3,0,0,1-2,1.82A6.51,6.51,0,0,1,874.25,525.65Z",
    transform: "translate(-796.17 -404.59)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M874.42,508.49l-9.49,2.94c-2.25.47-.06,4.4-.71,4.9-2.4,1.83-.71,5.65-2.23,5.75-.13,0-3.35,1.23-3.44,1.13-2.7-3.39-5.85-9.87-2.34-13.47,5.39-5.53,13.14-6.23,17.62-6.05C875.14,503.74,876.57,504.87,874.42,508.49Z",
    transform: "translate(-796.17 -404.59)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M867.89,517.05a.31.31,0,0,1-.19-.55c1-.79,1.84-.67,3.08-.4a.31.31,0,0,1-.13.61c-1.22-.27-1.84-.32-2.56.27A.31.31,0,0,1,867.89,517.05Z",
    transform: "translate(-796.17 -404.59)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M876.33,518.11a.43.43,0,0,1-.4-.3l-.26-.84a.42.42,0,0,1,.28-.53.43.43,0,0,1,.53.28l.26.84a.42.42,0,0,1-.28.53A.3.3,0,0,1,876.33,518.11Z",
    transform: "translate(-796.17 -404.59)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M874.86,515.43a.34.34,0,0,1-.21-.08.31.31,0,0,1,0-.44c.87-.92,1.53-1.53,2.77-1.41a.3.3,0,0,1,.28.33.29.29,0,0,1-.34.29c-.93-.08-1.4.3-2.26,1.21A.3.3,0,0,1,874.86,515.43Z",
    transform: "translate(-796.17 -404.59)"
  }))), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M870.57,519.89a.43.43,0,0,1-.41-.29l-.26-.85a.42.42,0,1,1,.81-.25l.26.85a.43.43,0,0,1-.28.53Z",
    transform: "translate(-796.17 -404.59)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M874.78,522.75a.29.29,0,0,1-.27-.23.28.28,0,0,1,.22-.33l1.2-.25a.79.79,0,0,0,.58-.5.81.81,0,0,0-.11-.75l-2.32-3.13a.29.29,0,0,1,0-.4.3.3,0,0,1,.4.06l2.33,3.14a1.36,1.36,0,0,1-.82,2.13l-1.2.25Z",
    transform: "translate(-796.17 -404.59)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M859.83,520.46c-2.6-.29-2.32,2.07-1.2,3.58s3.41,1.8,4.67,1.63S862,520.69,859.83,520.46Z",
    transform: "translate(-796.17 -404.59)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M861.46,524.44a.22.22,0,0,1-.13,0,2.26,2.26,0,0,0-.83-.43,4.21,4.21,0,0,1-.8-.35,1.7,1.7,0,0,1-.76-1.77.73.73,0,0,1,.83-.49,1.91,1.91,0,0,1,1.41.83.21.21,0,1,1-.34.24,1.53,1.53,0,0,0-1.12-.65c-.27,0-.34.09-.37.2a1.29,1.29,0,0,0,.55,1.27,3.44,3.44,0,0,0,.73.31,2.84,2.84,0,0,1,1,.5.22.22,0,0,1,0,.3A.21.21,0,0,1,861.46,524.44Z",
    transform: "translate(-796.17 -404.59)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M894.79,554.44,886,556.9a56.46,56.46,0,0,0,1.4,7.67s-4.5,7.79-5.44,9.36c-.51.85-2.13,2-3.58,4.85a30.36,30.36,0,0,0-2,4.34c-.17.6-.42,3.58-.42,3.58s.85.68,1.79-1c0,0,0,3.74-.13,5.34s1,1.66,1.47.89c0,0-.13,1.34,1,1.34s.9-1.4.9-1.4,1.23,1.87,1.83-1.15c0,0-.13.83.58.83.49,0,.89-.9,1.08-1.73a21.17,21.17,0,0,0,.38-5.19,45.35,45.35,0,0,0,1.3-6c.06-.64-.19-.57,1.66-1.79,1.13-.74,3.91-3.11,5.92-4.85a6,6,0,0,0,2-4.94Z",
    transform: "translate(-796.17 -404.59)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M855.19,638.91l-6.49-1.19c-2.1,1.85-4,2.14-5.87,2.76a4.85,4.85,0,0,0-3.32,4.22h23.36c0-7-1.79-7.79-1.79-7.79l-5.87,3.45.36-.52A.6.6,0,0,0,855.19,638.91Z",
    transform: "translate(-796.17 -404.59)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M881.92,638.89l5.52-1.17a12.29,12.29,0,0,0,5.38,2.76,4.85,4.85,0,0,1,3.31,4.22H874.27c0-7,1.79-7.79,1.79-7.79l5.87,3.45-.38-.54A.6.6,0,0,1,881.92,638.89Z",
    transform: "translate(-796.17 -404.59)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M849.59,557.73l-.1,0a.35.35,0,0,1-.23-.44l1.92-5.87a.34.34,0,0,1,.44-.23.35.35,0,0,1,.22.44l-1.91,5.88A.37.37,0,0,1,849.59,557.73Z",
    transform: "translate(-796.17 -404.59)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M884.33,557.38l2.49-10.8s-.11,6.9,1.77,9.6Z",
    transform: "translate(-796.17 -404.59)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M864.1,593.71a.27.27,0,0,1-.16-.06.26.26,0,0,1,0-.35l.73-.84.41-2a.27.27,0,0,1,.3-.2.25.25,0,0,1,.19.3l-.42,2a.24.24,0,0,1-.06.11l-.77.9A.26.26,0,0,1,864.1,593.71Z",
    transform: "translate(-796.17 -404.59)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M866.44,593.25a.3.3,0,0,1-.14,0,.25.25,0,0,1-.06-.35l.43-.63.33-2.58a.25.25,0,0,1,.29-.21.25.25,0,0,1,.21.28l-.34,2.64a.25.25,0,0,1,0,.11l-.47.68A.26.26,0,0,1,866.44,593.25Z",
    transform: "translate(-796.17 -404.59)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M877.52,587h0a.26.26,0,0,1-.22-.28l.29-2.86.6-2.5a.25.25,0,1,1,.49.12l-.6,2.47-.28,2.82A.26.26,0,0,1,877.52,587Z",
    transform: "translate(-796.17 -404.59)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M879.15,592.16h0a.25.25,0,0,1-.23-.26l.19-3.85v-2a.25.25,0,0,1,.5,0v2l-.19,3.86A.25.25,0,0,1,879.15,592.16Z",
    transform: "translate(-796.17 -404.59)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M881,592.1h0a.26.26,0,0,1-.23-.27l.3-3.54V586.4a.25.25,0,0,1,.25-.25.25.25,0,0,1,.25.25v1.91l-.3,3.56A.25.25,0,0,1,881,592.1Z",
    transform: "translate(-796.17 -404.59)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M882.83,591h0a.25.25,0,0,1-.21-.28l.43-2.6v-2.38a.25.25,0,0,1,.25-.25.25.25,0,0,1,.25.25v2.42l-.42,2.64A.27.27,0,0,1,882.83,591Z",
    transform: "translate(-796.17 -404.59)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M849.59,557.38l-11.23-2.89L848.88,560C849.16,559.08,849.42,558.17,849.59,557.38Z",
    transform: "translate(-796.17 -404.59)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M895,557l-.2-2.58L886,556.9s0,.33.11.84Z",
    transform: "translate(-796.17 -404.59)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M874.27,644.7h21.86a4,4,0,0,0-.3-1.4H874.3C874.28,643.74,874.27,644.2,874.27,644.7Z",
    transform: "translate(-796.17 -404.59)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M839.51,644.7h23.36c0-.5,0-1,0-1.4h-23A3.79,3.79,0,0,0,839.51,644.7Z",
    transform: "translate(-796.17 -404.59)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M891.55,565.54a.23.23,0,0,1-.14,0,6.08,6.08,0,0,0-3.94-.68.25.25,0,0,1-.29-.21.25.25,0,0,1,.2-.29,6.57,6.57,0,0,1,4.31.77.26.26,0,0,1,.07.35A.25.25,0,0,1,891.55,565.54Z",
    transform: "translate(-796.17 -404.59)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M971,553.17",
    transform: "translate(-796.17 -404.59)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1008.15,608.57l-9.44,27.16a2,2,0,0,0,.52,2.1l3.79,3.53c2.06,1.55,3.59.4,3.59,3.34H991.16a1.35,1.35,0,0,1-1.31-1.69,35.3,35.3,0,0,1,2.47-6.42c1.27-2.62,1.17-17.19,5.5-28.48S1008.15,608.57,1008.15,608.57Z",
    transform: "translate(-796.17 -404.59)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1024.58,607.48l-8.14,28.16a2,2,0,0,0,.7,2.14l4.66,3.58c2.06,1.55,5.09.4,5.09,3.34h-17.66a1.35,1.35,0,0,1-1.33-1.57,23.72,23.72,0,0,1,2.19-6.54c1.28-2.62,0-18.14,4.37-29.42S1024.58,607.48,1024.58,607.48Z",
    transform: "translate(-796.17 -404.59)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1008.15,608.57a18.63,18.63,0,0,0-1.54-2.4l-7.39-.87a14.08,14.08,0,0,0-1.4,2.81s4.95,2.72,9.47,2.94Z",
    transform: "translate(-796.17 -404.59)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1024.58,607.48a17,17,0,0,0-1.07-1.78l-8.7.63c-.12.26-.23.54-.35.84-.33.87-.63,1.78-.9,2.69a33.34,33.34,0,0,0,9.94,1.36Z",
    transform: "translate(-796.17 -404.59)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1023.59,564.83c-.34,2.8-.08,5.38-.42,11.66s-7.54-3.24-7.54-3.24V560.7Z",
    transform: "translate(-796.17 -404.59)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 200.52,
    y: 110.62,
    width: 10.48,
    height: 21.43
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 210.38,
    y: 110.62,
    width: 10.48,
    height: 21.43
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M1001.6,530.54a3.23,3.23,0,0,1-1.55,2.77L994,537l-1.56.86a10.39,10.39,0,0,0-5.34,8l-2.34,21.46h8.1l-2.23,3.09,28.51-3.87h7.31V547a11.39,11.39,0,0,0-5.92-10l-9.87-5v-3.91l-9.09-3.35Z",
    transform: "translate(-796.17 -404.59)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1001.35,531.8l7.55,13.48,1.79-12.92v-4.25l-9.09-5v7.42A3.37,3.37,0,0,1,1001.35,531.8Z",
    transform: "translate(-796.17 -404.59)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M1020.79,543.78c2.48,6.7,2.7,10.6,0,15.66-2.11,3.94-2.49,9.58-2.49,11.9H990.66l-1.56-19.26",
    transform: "translate(-796.17 -404.59)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1018.3,571.34c0-2.32-.23-7.35,1.88-11.29a14.42,14.42,0,0,0,1.25-10.88s2.36,3.36,1.3,9-2.08,5.52-2.08,9.21v8.71l-2.35-4.72",
    transform: "translate(-796.17 -404.59)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1010.69,531.08v-4.65l-8.38-1.67C1004.18,529.49,1007.53,531.37,1010.69,531.08Z",
    transform: "translate(-796.17 -404.59)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1009.29,548a.24.24,0,0,1-.14,0l-7.44-5.21a.25.25,0,0,1-.09-.27l.67-2.62L1000,539a.26.26,0,0,1-.17-.21l-.39-4.77a.26.26,0,0,1,.23-.27.25.25,0,0,1,.27.23l.38,4.61,2.32.85a.24.24,0,0,1,.15.3l-.69,2.67,7.11,5,4.17-4.9-1.64-2.68a.26.26,0,0,1,.13-.37l2.24-.82-1.53-4.54a.23.23,0,0,1,.16-.31.24.24,0,0,1,.31.15l1.61,4.77a.25.25,0,0,1-.15.31l-2.18.81,1.57,2.58a.24.24,0,0,1,0,.29l-4.44,5.21A.25.25,0,0,1,1009.29,548Z",
    transform: "translate(-796.17 -404.59)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M998.29,509.61l1.27,7.88c.61,6.59,5.3,12.62,11.18,12.07,5.47-.5,5.18-6.93,4.57-13.53l-.73-7.92Z",
    transform: "translate(-796.17 -404.59)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1022.48,528.14a5.1,5.1,0,0,1-.52-4.9,5.93,5.93,0,0,0-1.23-5.49,30.58,30.58,0,0,1-4.55-7.92c-1.3-3-4.28-6.56-10.43-5.06-3.66-1-7.84,2.07-9.14,5.06s-1.79,6-3.55,7.92a5.93,5.93,0,0,0-1.23,5.49,5.08,5.08,0,0,1-.52,4.9,7.87,7.87,0,0,0-1.49,5.39c.19,1,.79,2.79-.06,4.54s-1.65,5.86,2.92,7.21c0,0,3,4.44,9.31,2.27a4.66,4.66,0,0,1-2.4-5.52c.91-4.09,2-4.74.9-8.24s-1.79-3.68-.37-5.3c1.93-2.2,2.28-4.48,1.64-8.28a4.5,4.5,0,0,1,1.87-4.47c1.4-1,2.76-.64,4.51-5.9,3.05,4.83,4.8,5,7.75,6.95-.17,1.73.78,6,.22,7.45-.48,4.84-5.42,7.78-5.42,7.78a5.33,5.33,0,0,0,2.07,4c2.55,1.86,5.35,3.52,5.35,6.08a3.17,3.17,0,0,1-3,3.3c4.35,5,10.71,1,8.18-6.17-.65-1.84.52-4.67.71-5.71A7.87,7.87,0,0,0,1022.48,528.14Z",
    transform: "translate(-796.17 -404.59)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1011.7,521.81h-.32a.26.26,0,0,1-.24-.27.28.28,0,0,1,.27-.24c.47,0,.75,0,.84-.12s0-1.12-.38-2.32l-.17-.61a.27.27,0,0,1,.18-.32.25.25,0,0,1,.31.18l.17.61c.43,1.56.65,2.34.29,2.78A1.17,1.17,0,0,1,1011.7,521.81Z",
    transform: "translate(-796.17 -404.59)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1018.3,571.34s6.31,5.44,9.38,8.76,2.68,8.68,1.34,15.58-2.54,12.44-2.54,12.44-12.63,3.32-32.89-1a86.41,86.41,0,0,1,3.76-15.89s-9.12-.16-7.71-7.39l2.55-10.06.51-2.49Z",
    transform: "translate(-796.17 -404.59)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1007.89,519.07a.52.52,0,0,1-.51-.47l-.08-.9a.51.51,0,0,1,.46-.56.51.51,0,0,1,.55.46l.09.91a.51.51,0,0,1-.46.55Z",
    transform: "translate(-796.17 -404.59)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1005.43,515.8a.29.29,0,0,1-.21-.09.26.26,0,0,1,0-.36,3.48,3.48,0,0,1,3.73-.2.25.25,0,0,1,.14.33.25.25,0,0,1-.33.14c-1.39-.57-2.38-.53-3.23.13A.21.21,0,0,1,1005.43,515.8Z",
    transform: "translate(-796.17 -404.59)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1014.24,518.48a.5.5,0,0,1-.5-.46l-.09-.91a.51.51,0,0,1,.46-.55.53.53,0,0,1,.56.46l.08.9a.51.51,0,0,1-.46.56Z",
    transform: "translate(-796.17 -404.59)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1018.3,571.34H996.68s6,1.16,11.21,1.61,12.76.45,12.76.45Z",
    transform: "translate(-796.17 -404.59)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1013.16,515.25a.25.25,0,0,1-.21-.12.26.26,0,0,1,.07-.35c1.42-.91,2.6-1.07,3.71-.49a.26.26,0,0,1,.11.34.24.24,0,0,1-.34.11c-1-.49-1.94-.35-3.2.47A.33.33,0,0,1,1013.16,515.25Z",
    transform: "translate(-796.17 -404.59)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1013.67,523.52a.22.22,0,0,1,.21.3,2.22,2.22,0,0,1-1.94,1.49,3.23,3.23,0,0,1-2.6-1,.22.22,0,0,1,.13-.37Z",
    transform: "translate(-796.17 -404.59)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M985.77,567.35l-.65,4.54a1.34,1.34,0,0,0,.71,1.39,47.55,47.55,0,0,0,14.66,4.91,3,3,0,0,1,2.17,1.4,11.4,11.4,0,0,0,4,2.75l1.66,2.68s-.57,1.78,1,2.42l.32-2.68V584l.64,1.14s-.38,2.49,1.15,2.75l.25-1.11a1.28,1.28,0,0,0,.9.22l.55-3.11s.13.81.81.94l-.38-3.66-3.54-3.55-4.59-2.28c-2.47-1.11-8.92-6-12.67-7l.22-.95Z",
    transform: "translate(-796.17 -404.59)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1011.59,587a.25.25,0,0,1-.25-.25v-2.26l-1.38-2.27a.26.26,0,0,1,.08-.35.26.26,0,0,1,.35.09l1.42,2.33a.28.28,0,0,1,0,.13v2.33A.25.25,0,0,1,1011.59,587Z",
    transform: "translate(-796.17 -404.59)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1013,584.14a.25.25,0,0,1-.25-.25v-.63l-1.94-2.27a.25.25,0,0,1,0-.36.26.26,0,0,1,.35,0l2,2.34a.27.27,0,0,1,.06.17v.72A.25.25,0,0,1,1013,584.14Z",
    transform: "translate(-796.17 -404.59)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M996.21,567.6h-2.74a.25.25,0,0,1,0-.5H996l.89-12.63a.24.24,0,0,1,.27-.23.25.25,0,0,1,.23.27l-.91,12.86A.25.25,0,0,1,996.21,567.6Z",
    transform: "translate(-796.17 -404.59)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M997.35,591.53l-.09,0a.25.25,0,0,1-.15-.32c.3-.82.62-1.62.95-2.39a.25.25,0,0,1,.32-.13.25.25,0,0,1,.13.33c-.32.75-.63,1.55-.93,2.36A.23.23,0,0,1,997.35,591.53Z",
    transform: "translate(-796.17 -404.59)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M990.83,644.7h15.78c0-2.94-1.53-1.79-3.59-3.34a8,8,0,0,0-5.67.66c-2.74,1.53-4.74,1.7-5.29-.46a14.29,14.29,0,0,1-.28-3.81,32.71,32.71,0,0,0-2,5.59A1.09,1.09,0,0,0,990.83,644.7Z",
    transform: "translate(-796.17 -404.59)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1008.94,644.7h18c0-2.94-3-1.79-5.09-3.34h0c-.19-.17-1.64-1.24-4.18.19-2.73,1.53-5,1.68-6.25.17a15,15,0,0,1-1.92-3.63,21.12,21.12,0,0,0-1.56,5.39A1.09,1.09,0,0,0,1008.94,644.7Z",
    transform: "translate(-796.17 -404.59)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1009.55,584.25a.27.27,0,0,1-.21-.12l-.6-1a.25.25,0,0,1,.08-.34.25.25,0,0,1,.35.08l.59,1a.25.25,0,0,1-.08.35A.28.28,0,0,1,1009.55,584.25Z",
    transform: "translate(-796.17 -404.59)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1023.45,566.57h-4.28a11,11,0,0,0,4.23,1.47Z",
    transform: "translate(-796.17 -404.59)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M992.89,567.35h-7.12a28.08,28.08,0,0,0,6.9.95Z",
    transform: "translate(-796.17 -404.59)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1017.69,561.72c-1.35,0-2.73-.11-4.19-.23-1.74-.13-3.53-.28-5.61-.28a.25.25,0,0,1-.25-.25.25.25,0,0,1,.25-.25c2.1,0,3.9.15,5.65.29,1.45.11,2.82.22,4.15.22a.25.25,0,0,1,0,.5Z",
    transform: "translate(-796.17 -404.59)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 213.38,
    cy: 145.89,
    r: 0.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 214.38,
    cy: 151.89,
    r: 0.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 213.88,
    cy: 157.89,
    r: 0.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 213.88,
    cy: 163.89,
    r: 0.5
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M886.75,610.4a38.8,38.8,0,0,1-2.94,4.55c-1.66,2.17-10.29,11.71-10.29,11.71-2,2.08-.1,3.36,3.75,2.21l11-4.47c3.32-1.53,2.56-3.57,2.05-6s4.21-7.28,4.21-7.28Z",
    transform: "translate(-796.17 -404.59)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M890.46,619c-10.84,5.74-12.14,5.36-13.19,3.44h0c-2,2.29-3.75,4.18-3.75,4.18-2,2.08-.1,3.36,3.75,2.21l11-4.47C891.3,623,890.93,621.18,890.46,619Z",
    transform: "translate(-796.17 -404.59)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "139.34 152.78 139.34 171.47 111 171.47 113.34 149.9 139.34 152.78"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M916,534.56c9-1.27,12.22-3.94,12.22-3.94a14.44,14.44,0,0,1-1.46-4.37c-.67-3.12-.24-9.12-3.79-15.22a11.22,11.22,0,0,0-11.15-5.85c-4.54.64-7.95,4.22-9.08,8.73-1.7,6.85.38,12.5.61,15.68a14.75,14.75,0,0,1-.18,4.6S907,535.84,916,534.56Z",
    transform: "translate(-796.17 -404.59)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M919.19,525.46v5.25c0,2,2.43,2.07,4,2.3l6.75.82a5.51,5.51,0,0,1,4.78,4.51l1.7,9.58H892.31l.38-5.55a7.43,7.43,0,0,1,5.7-6.7l6.7-1.57c1.54-.23,4.42-1.38,4.42-3.39v-8.58",
    transform: "translate(-796.17 -404.59)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M909.51,523.51v3.42a15.56,15.56,0,0,0,10.06,4.93,1.73,1.73,0,0,1-.38-1.15v-5.15Z",
    transform: "translate(-796.17 -404.59)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M922.56,516.79c1,6.86.61,12.39-4.37,13.1-4.69.67-9.31-3.56-10.52-9.82a15.34,15.34,0,0,1,2.93-4.75c1.85-1.84,3.18-2.67,3.28-5.33,0,0,2-1.91,5.81,1C922,512.76,922.56,516.79,922.56,516.79Z",
    transform: "translate(-796.17 -404.59)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M914.79,519.53a.37.37,0,0,1-.38-.33l-.11-.73a.38.38,0,0,1,.76-.11l.1.74a.37.37,0,0,1-.32.43Z",
    transform: "translate(-796.17 -404.59)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M918.5,522.09a.26.26,0,0,1-.26-.25.26.26,0,0,1,.25-.26c.81,0,1.08-.16,1.16-.28s0-.45-.09-.76l-.06-.19-.83-2.45a.26.26,0,0,1,.16-.33.26.26,0,0,1,.32.16l.9,2.65a1.38,1.38,0,0,1,0,1.22c-.23.32-.71.47-1.56.49Z",
    transform: "translate(-796.17 -404.59)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M935.51,562.16l-18.13,3.9,4,5.28s9,0,14.17-.52Z",
    transform: "translate(-796.17 -404.59)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M920.72,524.16a.29.29,0,0,1,.34.3,2.16,2.16,0,0,1-1.95,1.64,2.14,2.14,0,0,1-2.33-1,.27.27,0,0,1,.24-.37Z",
    transform: "translate(-796.17 -404.59)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M912.41,516.93a.3.3,0,0,1-.16,0,.27.27,0,0,1,0-.36,3.28,3.28,0,0,1,3.53-1,.26.26,0,0,1,.15.33.26.26,0,0,1-.33.15,2.79,2.79,0,0,0-2.94.85A.26.26,0,0,1,912.41,516.93Z",
    transform: "translate(-796.17 -404.59)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M938.13,561.16l-3.44-22.82a5.51,5.51,0,0,0-4.78-4.51l-6.75-.82a15.43,15.43,0,0,1-2.3-.4h0c.81,2.42-2.31,7.47-6.05,7.47-4.15,0-6.64-3.25-7.24-6.78v0h0a6.45,6.45,0,0,1-.59.29l-.08,0a4.58,4.58,0,0,1-.58.22l-.09,0c-.19.06-.37.12-.55.16l-.06,0c-.19,0-.36.08-.52.1h0l-3.35.79-3.35.78a7.43,7.43,0,0,0-5.7,6.7L891.87,567a4.46,4.46,0,0,0,4.46,4.6h9.82l5.1-8.3,2.81,7,18.69-2.1A6.13,6.13,0,0,0,938.13,561.16Zm-37.34,1.32v-9.31c.63,5.74,2.68,9.06,4.08,10.21Z",
    transform: "translate(-796.17 -404.59)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M921.22,518.62a.39.39,0,0,1-.38-.33l-.1-.74a.38.38,0,0,1,.32-.43.4.4,0,0,1,.44.33l.1.73a.38.38,0,0,1-.33.43Z",
    transform: "translate(-796.17 -404.59)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M923,515.42a.21.21,0,0,1-.15,0,2.77,2.77,0,0,0-3.06,0,.26.26,0,0,1-.36,0,.25.25,0,0,1,.05-.36,3.28,3.28,0,0,1,3.67,0,.25.25,0,0,1,0,.36A.23.23,0,0,1,923,515.42Z",
    transform: "translate(-796.17 -404.59)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M910.6,515.32c-3.24,3.22-.8,13.46,4.52,16.78,0,0-5.65,3.93-12,2.09,2.67-2.67,1.19-16.37,1.19-16.37Z",
    transform: "translate(-796.17 -404.59)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M897.46,632.44l6-51.06s.63-8.85,8.8-7.09,5.62,15.39,5.62,15.39c-.76,8.42-7.66,39.32-8.17,42.76Z",
    transform: "translate(-796.17 -404.59)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M911.25,563.25c-6.29,1.92-8.47,4.55-8.71,4.64a35.91,35.91,0,0,0-2.85,2.83c-.32.38-2.23,3.12-2.23,3.12s0,.84,1,.45l-.9,2s.58.87,1.54-.21v.71s.38.46,1.66-.56l1.27-1-.25.7s.76.89,2.68-.89,1.59-1.73,2.68-2.24a9.58,9.58,0,0,0,3.76-3.38c1-1.66,2.23-1.34,2.23-1.34",
    transform: "translate(-796.17 -404.59)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M898.49,574.54a.23.23,0,0,1-.14,0,.25.25,0,0,1-.07-.35l1.32-2,2-2a.25.25,0,0,1,.35,0,.24.24,0,0,1,0,.35l-2,1.91-1.28,1.94A.26.26,0,0,1,898.49,574.54Z",
    transform: "translate(-796.17 -404.59)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M901.76,595.87l-2.35,20c5-8,13.9-25.39,16.44-36.25Z",
    transform: "translate(-796.17 -404.59)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M891.9,614.32a28.59,28.59,0,0,1,2.63-3.2l-7.78-.72A13.54,13.54,0,0,0,891.9,614.32Z",
    transform: "translate(-796.17 -404.59)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M899.13,576.31a.27.27,0,0,1-.15,0,.25.25,0,0,1-.06-.35l1.92-2.64,2.46-2.12a.25.25,0,1,1,.33.38l-2.43,2.08-1.87,2.6A.28.28,0,0,1,899.13,576.31Z",
    transform: "translate(-796.17 -404.59)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M902.06,575.44a.23.23,0,0,1-.17-.08.25.25,0,0,1,0-.35l2.81-2.84a.25.25,0,0,1,.36,0,.26.26,0,0,1,0,.35l-2.81,2.84A.25.25,0,0,1,902.06,575.44Z",
    transform: "translate(-796.17 -404.59)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M935.51,576.06h-4.6s-10.54-8.55-18.12-9.36-11.75,9.19-13.66,12.51L883.81,607.8s4.06,5.37,13.65,6.26c0,0,12.76-21.08,16.89-32.68,0,0,4.44,1.79,3.54,8.3,0,0,8.85,2.42,16.47,0C937.17,588.78,937.42,580.06,935.51,576.06Z",
    transform: "translate(-796.17 -404.59)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M918,589.15h0a.24.24,0,0,1-.22-.27c.37-4.8-2.37-6.68-3.22-7.15a.24.24,0,0,1-.1-.34.24.24,0,0,1,.34-.09c.91.5,3.87,2.52,3.47,7.62A.25.25,0,0,1,918,589.15Z",
    transform: "translate(-796.17 -404.59)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M909.72,632.44c-.51,3.45-.25,7.66-1,12.26H897a7.86,7.86,0,0,1,3.18-5.49,51.68,51.68,0,0,1,2.92-6.77Z",
    transform: "translate(-796.17 -404.59)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M897,644.7H908.7a47.67,47.67,0,0,0,.55-5.49c-2.64,1.91-6,3.44-9.11,0A7.86,7.86,0,0,0,897,644.7Z",
    transform: "translate(-796.17 -404.59)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M911.25,563.5a.26.26,0,0,1-.24-.18.25.25,0,0,1,.17-.31c5.73-1.74,15.51-4.11,17.14-4.5l-1.82-9.12a.24.24,0,0,1,.19-.29.25.25,0,0,1,.3.19l1.87,9.36a.25.25,0,0,1-.19.29c-.11,0-11.13,2.66-17.34,4.55Z",
    transform: "translate(-796.17 -404.59)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M909.52,634.32c.05-.64.11-1.28.2-1.88h-6.66A15.52,15.52,0,0,0,909.52,634.32Z",
    transform: "translate(-796.17 -404.59)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M936.74,582.24a16.16,16.16,0,0,0-1.23-6.18h-4.6A25.38,25.38,0,0,1,936.74,582.24Z",
    transform: "translate(-796.17 -404.59)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M941.64,636.59c-4,3.89-6.11,4.13-7.92,4.69-2.16.67-2.16,3.42-2.16,3.42h20.29s.51-3-.7-10.38S941.64,636.59,941.64,636.59Z",
    transform: "translate(-796.17 -404.59)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M978.86,636.59c4,3.89,6.1,4.13,7.92,4.69,2.16.67,2.16,3.42,2.16,3.42H968.65s-.51-3,.7-10.38S978.86,636.59,978.86,636.59Z",
    transform: "translate(-796.17 -404.59)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M947.63,570.44l-12.88,9.9a5.77,5.77,0,0,0-2.2,5.41l7.29,50.39s7.41,1.34,12-1.82c0,0-1.28-31.88-2.81-43.49,2.52-1.85,8.1-2.05,13.85-3.32,0,0,5.81,1.53,7.34,2,0,0-1.4,24.38-2,45.32a17.56,17.56,0,0,0,12.64,1l5.1-47c.64-6.24-5.91-18.46-5.91-18.46Z",
    transform: "translate(-796.17 -404.59)"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "176.98 123.25 185.11 128.11 185.9 136.73 151.46 136.73 152.24 128.11 160.38 123.25"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M972.3,511.43l-10.79,9.48h-1.84v12.27l5.22-2.89,5.22,2.89V522.45a11.73,11.73,0,0,1,1.36-4.94Z",
    transform: "translate(-796.17 -404.59)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M970.13,521.89a12.62,12.62,0,0,1,1.34-4.38l.42-3.06-9,6.46-2.21,2.77C966.37,525.39,970.12,522.07,970.13,521.89Z",
    transform: "translate(-796.17 -404.59)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M954.77,511.43c-2.44-3.33-3.37-7.79-.2-11,3.91-4,8.82-2.8,12-2.8a9.49,9.49,0,0,1,8.57,5.42c2,4.23-.94,11-3.67,14.47a10.11,10.11,0,0,0-1.36-5.36",
    transform: "translate(-796.17 -404.59)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M971,510.4c1.5-.52,2.27.29,2.41,1.76a2.54,2.54,0,0,1-3.26,2.74",
    transform: "translate(-796.17 -404.59)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M960.39,502.08c3.3-1.05,5.12,2.18,5.48,4.7s3.74,2.22,3.74,2.22c.13,1.14,1.4,1.4,1.4,1.4,0,8.91-3.12,13.68-10.21,13.68-3.5,0-6-4.77-6-13.68,0,0,.14-2.3.14-3.62C954.89,504.24,957.09,501,960.39,502.08Z",
    transform: "translate(-796.17 -404.59)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M957.3,511.86a.44.44,0,0,1-.44-.43v-.88a.44.44,0,0,1,.44-.43.43.43,0,0,1,.43.43v.88A.43.43,0,0,1,957.3,511.86Z",
    transform: "translate(-796.17 -404.59)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M960.25,515.73a1.27,1.27,0,0,1-.78-.23,1.43,1.43,0,0,1-.48-1.25c0-1,.25-4.27.26-4.41a.24.24,0,0,1,.27-.24.26.26,0,0,1,.24.28s-.26,3.43-.26,4.37a1,1,0,0,0,.27.84c.24.18.71.17,1.4,0a.26.26,0,0,1,.32.17.26.26,0,0,1-.17.32A3.66,3.66,0,0,1,960.25,515.73Z",
    transform: "translate(-796.17 -404.59)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M963.2,518.17a.27.27,0,0,1,.25.38,2.86,2.86,0,0,1-5.12,0,.27.27,0,0,1,.25-.38Z",
    transform: "translate(-796.17 -404.59)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M954.91,508.43a.36.36,0,0,1-.25-.11.33.33,0,0,1,0-.47,3.18,3.18,0,0,1,3.47-.24.34.34,0,0,1,.12.46.33.33,0,0,1-.45.11,2.56,2.56,0,0,0-2.7.17A.35.35,0,0,1,954.91,508.43Z",
    transform: "translate(-796.17 -404.59)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M964,511.86a.43.43,0,0,1-.43-.43v-.88a.43.43,0,0,1,.86,0v.88A.43.43,0,0,1,964,511.86Z",
    transform: "translate(-796.17 -404.59)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M966.37,508.43a.35.35,0,0,1-.22-.08,2.56,2.56,0,0,0-2.7-.17.32.32,0,0,1-.45-.11.33.33,0,0,1,.12-.46,3.22,3.22,0,0,1,3.47.24.33.33,0,0,1,0,.47A.32.32,0,0,1,966.37,508.43Z",
    transform: "translate(-796.17 -404.59)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "168.72 125.7 162.75 120.8 160.38 123.25 165.13 129.25 168.72 125.7"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "168.64 125.7 174.61 120.8 176.98 123.25 172.23 129.25 168.64 125.7"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M961.3,534.1a.25.25,0,0,1-.18-.08.24.24,0,0,1,0-.35l3.59-3.56a.33.33,0,0,1,.18-.07.29.29,0,0,1,.18.07l3.5,3.56a.25.25,0,0,1,0,.36.24.24,0,0,1-.35,0l-3.33-3.38L961.47,534A.26.26,0,0,1,961.3,534.1Z",
    transform: "translate(-796.17 -404.59)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M982.05,531.14l-8.9-3.3-8.26,11.62-8.35-11.62L948,531a10.39,10.39,0,0,0-6.22,6.39l-6.82,20-1.28,22.21,10.21-2.17s.94-11.91,1-18.21l1.95-4.26.72,15.49H980l6.59-31A7.23,7.23,0,0,0,982.05,531.14Z",
    transform: "translate(-796.17 -404.59)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M946.89,554.74a.26.26,0,0,1-.25-.24L946,541.08a.25.25,0,0,1,.24-.26.26.26,0,0,1,.26.23l.62,13.43a.25.25,0,0,1-.24.26Z",
    transform: "translate(-796.17 -404.59)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M943.93,577.42l3,1.62,2.09,4.25a1.32,1.32,0,0,1-2.09-.42l-.68-1.36-1-.39,1,2.52s.44,1.89.68,2.72a14.18,14.18,0,0,1,0,3.25s-1.27,0-1.29-2l-.13-1.08-.37-.33s.07.39.14,1,0,3.91,0,3.91-1,.64-1.32-1a13.18,13.18,0,0,1-.29-2.68l-1-2.51.38,2.73-.34,3.55s-1.32.45-1.4-1.3l0-2.13-.7-2.49-.17,2.66-.32,3.2s-1.36.21-1.34-1.58v-2.17s-.81-1.68-1.25-2.64-.82-1.72-.69-5.84Z",
    transform: "translate(-796.17 -404.59)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M969,550.73a.27.27,0,0,1-.17-.06.25.25,0,0,1,0-.35l9.55-11.11a.25.25,0,0,1,.35,0,.24.24,0,0,1,0,.35l-9.56,11.11A.21.21,0,0,1,969,550.73Z",
    transform: "translate(-796.17 -404.59)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M958.3,541.07s-1.47-4.44-1.76-5.65a5.2,5.2,0,0,0-1.77-2.81c-.88-.76-2.73-2.61-2.73-2.61l-3.13-2.88a1.64,1.64,0,0,0,0,2,6.9,6.9,0,0,0,1.66,1.78l-2.94-.32-2.1.77s-.07,1.12,1.4,1.21l-2.1.83s-.21,1,1.59,1.14l-1.6.71s.19,1,1.73,1l1.54-.06,2.16,1.78a9.26,9.26,0,0,0,3.64,5.81",
    transform: "translate(-796.17 -404.59)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M968.34,566.82a2.33,2.33,0,0,1-1.8-.85l-14.91-17.89a.25.25,0,1,1,.38-.32l14.91,17.89a1.84,1.84,0,0,0,2.54.29,82.38,82.38,0,0,0,12.41-11.61.24.24,0,0,1,.35,0,.25.25,0,0,1,0,.35,82.9,82.9,0,0,1-12.5,11.69A2.34,2.34,0,0,1,968.34,566.82Z",
    transform: "translate(-796.17 -404.59)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M966.73,565.81a2.09,2.09,0,0,0,2.88.33,82.52,82.52,0,0,0,12.45-11.65l1.86-2.41-1.1,5.17s-11.81,13.19-16.09,8.56",
    transform: "translate(-796.17 -404.59)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M953.38,533.93a.25.25,0,0,1-.19-.09L951,531.3l-.49-.1a.25.25,0,0,1-.19-.3.26.26,0,0,1,.29-.19l.58.12a.29.29,0,0,1,.14.08l2.23,2.6a.25.25,0,0,1,0,.36A.23.23,0,0,1,953.38,533.93Z",
    transform: "translate(-796.17 -404.59)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M951.56,534.83a.23.23,0,0,1-.17-.07l-1.79-1.7-2-.4-.63.19a.25.25,0,0,1-.15-.47l.69-.22h.13l2.09.42a.23.23,0,0,1,.12.06l1.84,1.76a.25.25,0,0,1,0,.36A.24.24,0,0,1,951.56,534.83Z",
    transform: "translate(-796.17 -404.59)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M950.44,535.87a.25.25,0,0,1-.16-.06l-1.46-1.19a1.15,1.15,0,0,0-1.07-.2l-1.25.4a.25.25,0,0,1-.31-.16.25.25,0,0,1,.16-.32l1.24-.4a1.69,1.69,0,0,1,1.55.29l1.46,1.19a.25.25,0,0,1,0,.35A.26.26,0,0,1,950.44,535.87Z",
    transform: "translate(-796.17 -404.59)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M971,553.42a.27.27,0,0,1-.18-.08,162.67,162.67,0,0,0-12.57-12,19,19,0,0,0-6.91,5.91.25.25,0,1,1-.4-.31,18.89,18.89,0,0,1,7.26-6.13.25.25,0,0,1,.25,0A166.64,166.64,0,0,1,971.2,553a.25.25,0,0,1,0,.35A.28.28,0,0,1,971,553.42Z",
    transform: "translate(-796.17 -404.59)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M980,570.44H947.63l33.26,1.71C980.37,571.09,980,570.44,980,570.44Z",
    transform: "translate(-796.17 -404.59)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M959,580.35H959a.24.24,0,0,1-.17-.31l2.77-8.93a.26.26,0,0,1,.32-.17.25.25,0,0,1,.16.32l-2.77,8.93A.26.26,0,0,1,959,580.35Z",
    transform: "translate(-796.17 -404.59)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M961.14,576.74a.25.25,0,0,1-.13-.46l1.61-1,1.4-4.22a.26.26,0,0,1,.32-.16.26.26,0,0,1,.16.32l-1.43,4.3a.26.26,0,0,1-.11.14l-1.69,1A.31.31,0,0,1,961.14,576.74Z",
    transform: "translate(-796.17 -404.59)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M961.18,585.68s-8,1.44-12.1,5.15h0a1.64,1.64,0,0,1,.26-.16c2.63-1.68,8-1.92,13.58-3.15,0,0,1.68.44,3.47.93Z",
    transform: "translate(-796.17 -404.59)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M944.68,558.93a.25.25,0,0,1-.22-.12c-1.33-2.23-4.83-2.26-4.87-2.26a.26.26,0,0,1-.25-.25.25.25,0,0,1,.25-.25c.16,0,3.82,0,5.3,2.51a.25.25,0,0,1-.09.34Z",
    transform: "translate(-796.17 -404.59)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M970.38,589h0a.24.24,0,0,1-.21-.28c.21-1.64.42-3.08.42-3.08a.24.24,0,0,1,.28-.21.24.24,0,0,1,.21.28s-.2,1.44-.42,3.07A.24.24,0,0,1,970.38,589Z",
    transform: "translate(-796.17 -404.59)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.9a3383ecb94edf7813d157d899740acb.svg";
export { ForwardRef as ReactComponent };